import React from 'react';
import colors from '../../util/colors';

interface ErrorMessageProps {
  error: string;
  visible: boolean;
}

function ErrorMessage({error, visible}: ErrorMessageProps) {
  if (!visible || !error) return null;

  return <div style={{color: colors.alertRed}}>{error}</div>;
}

export default ErrorMessage;
